module.exports = __webpack_public_path__ + "media/images/disbursement_channels/momo-9d6ebb1c93f4d201b8ca516453a9f434.svg";